<template>
  <section>
    <qx-img-dialog ref="imgDialog" />
    <el-dialog
        :close-on-click-modal="false"
        title="附件预览框"
        :lock-scroll="true"
        :visible.sync="dialogFormVisible"
        width="1000px"
        class="roll-dialog"
    >
      <section v-loading="getDetailLoading">
        <el-checkbox  v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="checkedArr" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="item in photoInfo" :label="item" :key="item">
            <img :src="item" style="width:100px;height:100px;cursor:pointer; margin-bottom: 10px;"
                 v-if="item.substring(item.lastIndexOf('.') + 1) !== 'pdf'"
                 @click="previewImg(item)"/>
          </el-checkbox>
        </el-checkbox-group>
      </section>
      <section slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">退 出</el-button>
        <el-button
            type="primary"
            @click="handlePrinter"
            :loading="subLoading || getDetailLoading"
        >打 印</el-button>
      </section>
    </el-dialog>
  </section>
</template>

<script>

import {getOrderMoneyTypeAttach} from 'api/report';
import printJS from 'print-js';
export default {
  data () {
    return {
      prePayInfo: {},
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      selectBtn: '', // 选中的费用类型
      printable: [ // 选择打印的图片
        // 'http://tmsimg.baiduyuming.com/group1/M00/02/EB/rBAAZmOhxmuAKN3nAAAkFxd81Wc327_big.jpg',
        // 'http://tmsimg.baiduyuming.com/group1/M00/02/EB/rBAAZmOhxlKAFQjFAAAiKzptMdo171_big.jpg',
        // // 里面存放图片打印的URL 一般为后台返回数据
        // 'http://127.0.0.1:1080/group1/M00/02/6A/wKgAyWO9GlyADT7JAAAPNNJswJ4393_big.jpg?filename=1661850452386.jpg',
        // // 'http://127.0.0.1:1080/group1/M00/02/6A/wKgAyWO9FWCAcFNPAAARt2b7j5g187_big.jpg?filename=%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20220914141852.jpg',
        // 'http://tmsimg.baiduyuming.com/group1/M00/02/EB/rBAAZmOhxmuAKN3nAAAkFxd81Wc327_big.jpg',
        // 'http://tmsimg.baiduyuming.com/group1/M00/02/EB/rBAAZmOhxlKAFQjFAAAiKzptMdo171_big.jpg',
        // 'http://tmsimg.baiduyuming.com/group1/M00/02/EB/rBAAZmOhxmuAKN3nAAAkFxd81Wc327_big.jpg',
        // 'http://tmsimg.baiduyuming.com/group1/M00/02/EB/rBAAZmOhxlKAFQjFAAAiKzptMdo171_big.jpg',
      ],


      checkAll: false, // 全选状态
      photoInfo: [], // 图片数据合集
      checkedArr: [], // 选中的图片
      isIndeterminate: true,
    };
  },
  methods: {

    /**
     * @param {Array<Object>} data 选中的订单
     * @param {String} selectBtn 费用类型
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (data, selectBtn) {
      this.photoInfo = [];
      this.checkedArr = [];
      this.printable = [];
      this.checkAll = false;
      this.originData = data;
      this.selectBtn = selectBtn;
      const orderIds = data.map((item) => item.orderId);
      const res = await getOrderMoneyTypeAttach({
        orderIds: orderIds.toString(),
        moneyTypeName: selectBtn,
      });
      if (!res.failed) {
        const items = Array.isArray(res.items) ? res.items : [];
        this.photoInfo = items.map((item) => item && item.picFullUrl).filter(Boolean);
        if (!this.photoInfo.length) {
          this.$message.warning('当前费用没有可预览的图片附件');
          return;
        }
        this.dialogFormVisible = true; // 打开弹窗
      }
    },

    previewImg (url) {
      this.$refs.imgDialog.show(url);
    },
    // 点击批量打印按钮
    handlePrinter () {
      printJS({
        // 要打印的内容 放在了data里
        printable: this.printable,
        // 打印类型 目前为图片样式 可以根据上面的网址进行修改
        type: 'image',
        // 二维码样式 可以自己进行修改
        imageStyle: 'margin:2px; padding:0px; width:48%; float:left;',
        // 也可以设置以下参数 继承所有css样式 没试过image的 html的效果不错
        // targetStyles:['*']
      });
    },

    handleCheckAllChange (val) {
      this.checkedArr = val ? this.photoInfo : [];
      this.printable = this.checkedArr;
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange (value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.photoInfo.length;
      this.printable = this.checkedArr;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.photoInfo.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-checkbox-group .el-checkbox{
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  float: left;
  margin-bottom: 10px;
}
.roll-dialog ::v-deep .el-dialog .el-dialog__body {
  padding: 3px 30px;
  overflow-y: scroll;
  height: 400px;
}
</style>
